import DetailMovie from "./DetailMovie";

export default DetailMovie